// Dynamic styles function to handle theme-aware styling
export const getDragStyles = (theme) => ({
    dragging: {
        opacity: 0.6,
        transform: 'scale(0.95)',
    },
    timelineDropZone: {
        '&.drag-over': {
            backgroundColor: theme.palette.action.hover,
            outline: `2px dashed ${theme.palette.primary.main}`,
        }
    },
    dragHandle: {
        cursor: 'grab',
        opacity: 0.7,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 1,
        }
    },
    infoButton: {
        cursor: 'pointer',
        opacity: 0.7,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 1,
        }
    },
    videoCell: {
        transition: 'all 0.2s ease',
        '&:hover .drag-handle, &:hover .info-button': {
            opacity: 1,
            display: 'flex',
        }
    }
});